export interface Resolver<TContext, TResult> {
  isApplicable: (context: TContext) => boolean;
  resolve: (context: TContext) => TResult;
}

export const pickResolver = <TContext, TResult>(
  resolvers: readonly Resolver<TContext, TResult>[],
  fallback: Resolver<TContext, TResult>,
  context: TContext
): Resolver<TContext, TResult> =>
  resolvers.find((resolver) => resolver.isApplicable(context)) ?? fallback;
